<template>
  <div class="modal-window large split active">
    <div class="grid-x split">
      <div class="cell large-6 flex-column">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3 class="icon-heading small">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
              <span class="icon-heading-title">
                <span class="title" v-if="bilag">
                  Sendt faktura #{{invoiceNumber}}
                </span>
              </span>
            </h3>
          </div>
        </div>

        <div class="modal-window-body">
          <template v-if="mailLog">
            <div class="grid-x">
              <div class="cell">
                <label>Sendt</label>
                <p>{{mailLog.createdAt | avantidatetime}} av {{mailLog.createdBy}}</p>
              </div>
              <div class="cell large-6">
                <label>Fra</label>
                <p>{{mailLog.fromEmail}}</p>
              </div>
              <div class="cell large-6">
                <label>Til</label>
                <p>{{mailLog.toEmail}} <span v-if="mailLog.toKundenr">({{mailLog.toKundenr}})</span></p>
              </div>
            </div>

            <div class="grid-x">
              <div class="cell">
                <label>Emne</label>
                <p>{{mailLog.subject}}</p>
              </div>
            </div>

            <div class="grid-x">
              <div class="cell">
                <div class="input-container textarea">
                  <label>Tekst</label>
                  <textarea class="no-resize" readonly style="height: 140px;" :value="mailLog.content"></textarea>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell auto" v-if="item.bruker">
              <span class="avatar black" :class="strToAvatarClass(item.bruker.initials)">{{item.bruker.initials}}</span>
              <div class="dl-wrap">
                <span class="dl dt" v-if="item.Endring === 'ukInsert'">Opprettet av</span>
                <span class="dl dt" v-if="item.Endring === 'ukModify'">Endret av</span>
                <span class="dl dt" v-if="item.Endring === 'ukDelete'">Slettet av</span>
                <span class="dl dd">{{item.bruker.full_name}}</span>
              </div>
            </div>
            <div class="cell auto" v-else>
              <span class="avatar black" :class="strToAvatarClass('-')">-</span>
              <div class="dl-wrap">
                <span class="dl dt" v-if="item.Endring === 'ukInsert'">Opprettet av</span>
                <span class="dl dt" v-if="item.Endring === 'ukModify'">Endret av</span>
                <span class="dl dt" v-if="item.Endring === 'ukDelete'">Slettet av</span>
                <span class="dl dd">Ikke tillgjengelig</span>
              </div>
            </div>

            <div class="cell auto"><span class="text-small opacity-60">{{item.Dato | avantidate}}</span></div>
            <div class="cell shrink">
              <a href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            </div>
          </div>
        </div>
      </div>

      <div class="cell large-6 flex-column">
        <div class="modal-window-body no-padding">
          <div class="iframe-container pdf">
            <iframe v-if="pdfSource" id="pdfFrame" name="pdfFrame" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" :src="pdfSource + '#view=FitH&toolbar=1'"></iframe>
            <TheEmptyList v-if="!pdfSource && !$store.getters.isFormLoading" :title="'Objekt #' + objekt.Objektnr + ' PDF'" :message="'Kunne ikke laste inn pdf'" :large="false" :icon="'button-glyph-contract'"/>
            <TheLoader :active="!pdfSource && $store.getters.isFormLoading"/>
          </div>
        </div>
      </div>
    </div>

    <a v-if="!pdfSource" href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
      <span>Lukk</span>
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
    </a>
  </div>
</template>

<script>
import BilagService from '@/services/BilagService'

export default {
  name: 'HistoryItemBilagPdfModal',
  props: {
    bilag: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pdfSource: false,
      mailLog: null
    }
  },
  computed: {
    invoiceNumber: function () {
      if (this.bilag) {
        return this.bilag.twentyfourseven_invoice_id && this.bilag.Dato > '2019-12-31'
          ? this.bilag.twentyfourseven_invoice_id
          : this.bilag.Bilagsnr
      }

      return null
    }
  },
  created () {
    this.setFormLoading(true)
    this.fetch()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  methods: {
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    fetch: function () {
      const json = JSON.parse(this.item.Logg)
      const post = { hash: json.Hash }

      BilagService.getHistoricalBilagsPdf(this.bilag.Bilagsid, post)
        .then((response) => {
          let url = process.env.VUE_APP_AVANTI_API_URL + response.data.endpoint

          this.pdfSource = url
          this.mailLog = response.data.mailLog
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke hente PDF')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/HistoryItemBilagPdfModal.vue